import { AgResourceLanguage } from '../types';

export const paymentModalWIndow: AgResourceLanguage['paymentModalWIndow'] = {
  stripeCardField: {
    expiredLabel: 'Utgånget'
  },
  paymentMethodMissing: {
    noPaymentMethodCharged: 'Ingen betalningsmetod debiterad',
    missingPaymentMethod: 'Saknad betalningsmetod'
  }
};
